import React, { useState, useEffect } from 'react';
import { adminFetch } from './shared';

const COLORS = [
  { id: 'cyan', label: 'Azul' },
  { id: 'gold', label: 'Dorado (Januká)' },
  { id: 'green', label: 'Verde' },
  { id: 'red', label: 'Rojo' },
  { id: 'dark', label: 'Negro' },
];

const inputCls = "w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500";

export const AnnouncementModal = ({ onClose }) => {
  const [form, setForm] = useState({ enabled: false, type: 'both', emoji: '🕎', title: '', subtitle: '', cta_text: '', coupon_code: '', color: 'gold' });
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    adminFetch('/api/announcement').then(r => r.json()).then(d => {
      if (d && d.title !== undefined) setForm(f => ({ ...f, ...Object.fromEntries(Object.entries(d).filter(([k]) => k in f)) }));
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  const save = async () => {
    if (form.enabled && !form.title.trim()) { alert('Escribe el título del anuncio'); return; }
    setSaving(true);
    try {
      const res = await adminFetch('/api/admin/announcement', {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      onClose();
    } catch (e) { alert(`Error al guardar: ${e.message}`); }
    finally { setSaving(false); }
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div className="fixed inset-0 z-[60] bg-black/60 flex items-center justify-center p-3" onClick={onClose} data-testid="announcement-modal">
      <div className="bg-white rounded-xl w-full max-w-md max-h-[92vh] overflow-y-auto shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-slate-200 px-5 py-3 flex items-center justify-between">
          <h3 className="font-bold text-slate-800">📣 Anuncio de temporada</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700" data-testid="close-announcement-modal">✕</button>
        </div>
        {!loaded ? <p className="p-5 text-sm text-slate-400">Cargando…</p> : (
        <div className="p-5 space-y-3">
          <label className="flex items-center gap-2 text-sm font-semibold text-slate-700">
            <input type="checkbox" checked={form.enabled} onChange={(e) => set('enabled', e.target.checked)} data-testid="ann-enabled" />
            Mostrar anuncio en la tienda
          </label>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-semibold text-slate-600 mb-1">Dónde se muestra</label>
              <select value={form.type} onChange={(e) => set('type', e.target.value)} className={inputCls} data-testid="ann-type">
                <option value="bar">Barra superior</option>
                <option value="popup">Anuncio al abrir</option>
                <option value="both">Ambos</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-600 mb-1">Color</label>
              <select value={form.color} onChange={(e) => set('color', e.target.value)} className={inputCls} data-testid="ann-color">
                {COLORS.map(c => <option key={c.id} value={c.id}>{c.label}</option>)}
              </select>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-3">
            <div>
              <label className="block text-xs font-semibold text-slate-600 mb-1">Emoji</label>
              <input type="text" value={form.emoji} onChange={(e) => set('emoji', e.target.value)} className={inputCls} data-testid="ann-emoji" />
            </div>
            <div className="col-span-3">
              <label className="block text-xs font-semibold text-slate-600 mb-1">Título *</label>
              <input type="text" value={form.title} onChange={(e) => set('title', e.target.value)}
                placeholder='Ej: "¡Descuento de Januká! 20% en toda la tienda"' className={inputCls} data-testid="ann-title" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1">Subtítulo (popup)</label>
            <input type="text" value={form.subtitle} onChange={(e) => set('subtitle', e.target.value)}
              placeholder='Ej: "Válido hasta el 2 de enero"' className={inputCls} data-testid="ann-subtitle" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-semibold text-slate-600 mb-1">Código de cupón</label>
              <input type="text" value={form.coupon_code} onChange={(e) => set('coupon_code', e.target.value.toUpperCase())}
                placeholder="JANUKA20" className={inputCls} data-testid="ann-coupon" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-600 mb-1">Texto extra</label>
              <input type="text" value={form.cta_text} onChange={(e) => set('cta_text', e.target.value)}
                placeholder='Ej: "Aplícalo al pagar"' className={inputCls} data-testid="ann-cta" />
            </div>
          </div>
          <p className="text-[10px] text-slate-400">💡 Crea el cupón en la pestaña Cupones y ponlo aquí: los clientes lo copian con un toque. El texto se traduce solo al inglés. El anuncio se muestra una vez por visita.</p>
        </div>
        )}
        <div className="sticky bottom-0 bg-white border-t border-slate-200 px-5 py-3 flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 text-sm text-slate-600 hover:text-slate-800">Cancelar</button>
          <button onClick={save} disabled={saving}
            className="px-4 py-2 bg-cyan-600 text-white text-sm font-semibold rounded-lg hover:bg-cyan-700 disabled:opacity-60"
            data-testid="save-announcement">
            {saving ? 'Guardando…' : 'Guardar anuncio'}
          </button>
        </div>
      </div>
    </div>
  );
};
